import {gql} from "@apollo/client";

export const GET_NOTIFICATIONS = gql`
          query GetUserNotifications {
                   userNotifications {
                     
                       id
                       type
                       notificationUuid
                   }
                 
          }`;
